import arrowIcon from "../Assets/view-link-arrow-right.svg";
import { Link } from "react-router-dom";

function EachProject(props) {
  return (
    <>
      <Link className="eachProject-preview-link" to={props.projectLink}>
            <div className="eachProject">
              <div className="eachProject-image-container">
                <img className="eachProject-image" src={props.imageSrc} alt={props.projectTitle} />
              </div>
              <div className="eachProject-content-container">
                <p className="eachProject-title">{props.projectTitle}</p>
                <p className="text-bottom-border">View Project 
                {/* <img src={arrowIcon} alt="->" className="right-arrow"/> */}
                {" "}<i class="far fa-external-link-alt "></i>
                </p>
              </div>
            </div>
          </Link> 
    </>
  )
}

export default EachProject
